import { BaseContainerModel } from '../base-container.model';
import { app_tenant_hdr_RowClass } from '../../dbschema/app_tenant_hdr.model';
import { app_tenant_ext_RowClass } from '../../dbschema/app_tenant_ext.model';

export class TenantContainerModel extends BaseContainerModel {
  app_tenant_hdr: app_tenant_hdr_RowClass = new app_tenant_hdr_RowClass();
  app_tenant_exts: app_tenant_ext_RowClass[] = [];
}